import store from '../store'

/**
* Checks if a user is logged in
* @returns {Boolean} user loggedIn state
*/
export function isLoggedIn () {
  return store.getters.isLoggedIn
}

/**
* Auth guard that allows non-authenticated users only.
* @param to - the next route
* @param from - the previous route
* @param next - callback to transfer control to the next middleware
*/
export function noAuthOnly (to, from, next) {
  if (isLoggedIn()) {
    next({ path: '/' })
  } else {
    next()
  }
}

/**
* Auth guard allows authenticated users only.
* @param to - next route
* @param from - previous route
* @param next - callback to transfer control to the next middleware
*/
export function requireAuth (to, from, next) {
  // next()
  console.log(to)
  if (isLoggedIn()) {
    next()
  } else {
    store.dispatch('apps/forceLogin', { type: 'login', to: to })
    next(false)
  }
}

/**
* Saves the logged user's details
* @param {Object} user
*/
export function setSession (user) {
  // store.commit('setUser', user)
}

/**
* Resets the logged-in user
*/
export function clearSession () {
  setSession('')
}

/**
* Retrieves the logged in user
* @return {Object} user - Stored user
*/
export function getSession () {
  return store.getters.getLoggedUser
}
